import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialFeatured() {
  return <FadeIn delay={0.2} data-id="element-350">
      <section className="py-12 px-4 max-w-4xl mx-auto pt-[0px] pb-[0px]" data-id="element-351">
        <div className="bg-white border border-[#e2e8f0] rounded-2xl p-8 md:p-12 text-center relative overflow-hidden pt-[0px] pb-[0px] shadow-sm" data-id="element-352">
          <Quote className="absolute top-4 left-4 md:top-8 md:left-8 text-[#f1f5f9] w-16 h-16 md:w-24 md:h-24 -z-10 rotate-180" data-id="element-353" />

          <p className="text-xl md:text-3xl font-medium text-[#0f172a] leading-relaxed mb-6 italic relative z-10" data-id="element-354">
            "Subí 22 vatios de FTP en 10 semanas siguiendo el plan del Tomo 3.
            Sin entrenador, sin potenciómetro caro."
          </p>

          <div className="flex items-center justify-center gap-3" data-id="element-355">
            <div className="w-10 h-10 bg-[#22c55e] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-md" data-id="element-356">
              D
            </div>
            <div className="text-left" data-id="element-357">
              <p className="font-bold text-[#0f172a]" data-id="element-358">Diego F.</p>
              <p className="text-sm text-[#475569] font-medium" data-id="element-359">
                Ciclista amateur, Rosario
              </p>
            </div>
          </div>
        </div>
      </section>
    </FadeIn>;
}